import {
  common,
  dashboard,
  datacenters,
  environments,
  environmentWorkflow,
  requests,
  requestStatus,
  settings,
  system,
  upgradeWorkflow
} from './initial-state';
import { StoreState } from './types';

const initialState: StoreState = {
  system,
  lcopsDashboard: dashboard,
  common,
  environmentWorkflow,
  datacenters,
  environments,
  requests,
  settings,
  requestStatus,
  upgradeWorkflow
};

export default initialState;
